import React from "react";
import VoiceClonerApp from "./components/voicecloner";

function App() {
	return (
		<div className="App">
			<VoiceClonerApp />
		</div>
	);
}

export default App;
